import { render, staticRenderFns } from "./TrainingsHero.vue?vue&type=template&id=4051173c&scoped=true&"
import script from "./TrainingsHero.vue?vue&type=script&lang=js&"
export * from "./TrainingsHero.vue?vue&type=script&lang=js&"
import style0 from "./TrainingsHero.vue?vue&type=style&index=0&id=4051173c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4051173c",
  null
  
)

export default component.exports